import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type LearningContentLanguage = "en" | "hi";

export interface LearningDefaultsConfig {
  max_questions_per_quiz: number;
  default_diagnostic_question_count: number;
  default_practice_question_count: number;
  default_post_review_question_count: number;
  default_skill_assessment_question_count: number;
  default_content_language: LearningContentLanguage;
}

export type LearningDefaultsUpdate = LearningDefaultsConfig;

export const learningDefaultsKeys = {
  all: ["learning-defaults"] as const,
  me: () => [...learningDefaultsKeys.all, "me"] as const,
};

export function useLearningDefaults(enabled = true) {
  return useQuery<LearningDefaultsConfig>({
    queryKey: learningDefaultsKeys.me(),
    queryFn: () => api.get<LearningDefaultsConfig>("/me/learning-defaults"),
    enabled,
    staleTime: 30_000,
    retry: false,
  });
}

export function useUpdateLearningDefaults() {
  const qc = useQueryClient();
  return useMutation<LearningDefaultsConfig, Error, LearningDefaultsUpdate>({
    mutationFn: (body) => api.put<LearningDefaultsConfig>("/me/learning-defaults", body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: learningDefaultsKeys.all });
    },
  });
}
